<template>
  <div
    class="center-div"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="173.20508"
      height="200"
      @click="goToItem"
      @mouseover="selected"
      @mouseleave="xPosition = 0"
    >
      <defs>
        <mask
          id="mascara"
        >
          <path
            style="fill:#ffffff"
            d="m 173.66057,149.04362 -86.602541,50 -86.60254042,-50 4.4e-7,-100.000003 L 87.05803,-0.95638275 173.66057,49.043618 Z"
          />
        </mask>
      </defs>
      <g>
        <!-- <image
          class="imagen-enmascarada"
          y="0"
          :x="xPosition"
          :xlink:href="imagen"
          height="200"
          :width="fotoWidth"
          mask="url(#mascara)"
          @load="cargadaImagen"
        /> -->
        <image
          class="imagen-enmascarada"
          y="0"
          :x="xPosition"
          :xlink:href="imagen"
          height="200"
          :width="fotoWidth"
          mask="url(#mascara)"
          @load="cargadaImagen"
        />
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'HexagonGenerator',

    props: {
      img: String,
      localImg: Boolean,
      slug: String,
      baseUrl: String,
    },

    data: () => ({
      foto: new Image(),
      fotoWidth: 356,
      isLoading: false,
      xPosition: 0,
    }),

    computed: {
      imagen () {
        if (this.localImg) {
          return require(`@/assets/${this.img}`)
        }
        return this.img
      },

      medidas () {
        return {
          w: this.foto.width,
          h: this.foto.height,
        }
      },
    },

    created () {
      this.foto.src = this.imagen
      this.isLoading = true
    },

    methods: {
      cargadaImagen () {
        this.fotoWidth = this.fotoWidthCalc()
      },

      fotoWidthCalc () {
        let result = 356
        const w = this.foto.width
        const h = this.foto.height
        if (w && h) {
          result = w / h * 200
        }
        return result
      },

      goToItem () {
        this.$router.push(`${this.baseUrl}/${this.slug}`)
      },

      selected () {
        const r = 173.21 - this.fotoWidth
        this.xPosition = r
      },
    },
  }
</script>

<style scoped>
.center-div {
  display: flex;
  justify-content: center;
}
svg {
  cursor: pointer;
}
</style>
